import styled from "styled-components";

export const Con = styled.div``;

export const SidebarCon = styled.div;
